/** Routes reachable without an authenticated session (login shell). */
export const AUTH_PUBLIC_PATHS = [
  '/login',
  '/force-password-change',
  '/forgot-password',
  '/reset-password',
] as const;

export function isAuthPublicPath(pathname: string): boolean {
  return AUTH_PUBLIC_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

export function isAuthPublicReturnPath(path: string): boolean {
  const noHash = path.split('#')[0] ?? path;
  const pathname = noHash.split('?')[0] ?? noHash;
  return isAuthPublicPath(pathname);
}
